import { gql } from "@apollo/client";

const GET_MAPPINGS = gql`
  query GET_MAPPINGS($hcfId: ObjectId, $levels: [MappingLevel]) {
    mappings: requirementMappingList(hcfId: $hcfId, levels: $levels) {
      _id
      reqId
      requirement {
        name
        expiryType
      }
      level
      requiredBy
      hcfType
      hcpType
      validity
      requiredForBooking
      isOrientationRequirement
      domain
    }
  }
`;

const CREATE_MAPPINGS = gql`
  mutation CREATE_MAPPINGS(
    $reqId: ObjectId!
    $level: MappingLevel!
    $requiredBy: [String!]!
    $hcfType: [String]
    $hcpType: [String!]!
    $validity: Int
    $requiredForBooking: Boolean!
  ) {
    createRequirementMapping(
      reqId: $reqId
      level: $level
      requiredBy: $requiredBy
      hcfType: $hcfType
      hcpType: $hcpType
      validity: $validity
      requiredForBooking: $requiredForBooking
    ) {
      _id
      reqId
      requirement {
        name
        expiryType
      }
      level
      requiredBy
      hcfType
      hcpType
      validity
      requiredForBooking
    }
  }
`;

const DELETE_MAPPINGS = gql`
  mutation DELETE_MAPPINGS($_id: ObjectId!) {
    deleteRequirementMapping(_id: $_id)
  }
`;

const UPDATE_MAPPINGS = gql`
  mutation UPDATE_MAPPINGS(
    $_id: ObjectId!
    $reqId: ObjectId
    $level: MappingLevel
    $requiredBy: [String!]
    $hcfType: [String!]
    $hcpType: [String!]
    $validity: Int
    $requiredForBooking: Boolean!
  ) {
    updateRequirementMapping(
      _id: $_id
      reqId: $reqId
      level: $level
      requiredBy: $requiredBy
      hcfType: $hcfType
      hcpType: $hcpType
      validity: $validity
      requiredForBooking: $requiredForBooking
    ) {
      _id
      reqId
      requirement {
        name
        expiryType
      }
      level
      requiredBy
      hcfType
      hcpType
      validity
      requiredForBooking
      isOrientationRequirement
    }
  }
`;

export { GET_MAPPINGS, CREATE_MAPPINGS, UPDATE_MAPPINGS, DELETE_MAPPINGS };
